<template>
  <div
    class="d-flex flex-column gr-8"
  >
    <div>
      <div
        class="mb-4"
        :class="isMobile ? 'text-subtitle-1' : 'text-h6'"
      >
        {{ t(`Как самостоятельно зарегистрировать клинику на {siteName}`, { ...options, siteName }) }}
      </div>
      <ol class="d-flex flex-column gr-2 text-body-1 pl-5 mb-2">
        <li>{{ t('Выберите нужный город', options) }}</li>
        <li>{{ t('Найдите страницу вашей клиники', options) }}</li>
        <li>{{ t('Нажмите «Ваша страница?»', options) }}</li>
        <li>{{ t('Заполните все поля и следуйте инструкции', options) }}</li>
      </ol>
      <a
        class="text-body-1 primary--text link-decoration-none"
        :href="context.request.country.is_russia
          ? 'https://help.prodoctorov.ru/kak-zaregistrirovat-svoyu-kliniku-na-portale-prodoktorov/'
          : 'https://help.ydoc.me/kak-zaregistrirovat-svoyu-kliniku-na-portale-ydoc/'"
        target="_blank"
        rel="noopener noreferrer"
      >{{ t('Подробнее в статье', options) }}</a>
    </div>

    <v-btn
      v-if="isMobile"
      color="primary"
      depressed
      @click="openSearch"
    >
      {{ t('Найти клинику', options) }}
    </v-btn>

    <div
      v-if="context.company_contact.email"
      class="d-flex flex-column"
    >
      <div class="text-body-1 mb-3">
        {{
          t(
            'Если не нашли свою страницу или есть другие трудности, пришлите название клиники и полный адрес главного офиса на', /* eslint-disable-line */
            options,
          )
        }}
        <a
          :href="`mailto:${context.company_contact.email}`"
          class="primary--text link-decoration-none"
        >{{ context.company_contact.email }}</a>
      </div>
      <div class="text-body-1">
        {{ t('Ответим в течение 1 рабочего дня', options) }}.
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import I18NextVue from 'i18next'
import type { ContextStore } from 'src/components/pages/profile/lpus/register/index/types'
import useContextStore from 'src/store/useContextStore'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')
const siteName = computed(() => (context.request.country.is_russia ? 'ПроДокторов' : 'YDoc'))

const searchTriggerButton = ref<HTMLInputElement | null>(null)

function openSearch() {
  if (!searchTriggerButton.value) {
    searchTriggerButton.value = document.querySelector('[data-js-btn-search]')
  }

  searchTriggerButton.value?.click()
}
</script>
